import { render, staticRenderFns } from "./TrusteeIdentityCard.vue?vue&type=template&id=64fc05d0&scoped=true"
import script from "./TrusteeIdentityCard.vue?vue&type=script&lang=js"
export * from "./TrusteeIdentityCard.vue?vue&type=script&lang=js"
import style0 from "./TrusteeIdentityCard.vue?vue&type=style&index=0&id=64fc05d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc05d0",
  null
  
)

export default component.exports